//This file is automatically rebuilt by the Cesium build process.
export default "void featureIdStage(out FeatureIds featureIds, ProcessedAttributes attributes) {\n\
  initializeFeatureIds(featureIds, attributes);\n\
  initializeFeatureIdAliases(featureIds);\n\
}\n\
";
